import { gql } from "@apollo/client";

export const REMOVE_INDICACION = gql`
    mutation RemoveIndicacionEv($idIndicacionEvaluacion: Int!)
    {
        deleteIndicacionRIEv(idIndicacionEvaluacion: $idIndicacionEvaluacion)
    }
`;